import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { AdTemplateHeaderCtaButton } from "@fresh8/types/src";
import { computed } from "vue";

export function getCtaButton():
  | AdTemplateHeaderCtaButton
  | {
      visible: boolean;
      text: string;
      url: string;
      id: undefined;
    } {
  const brand = injectBrand();
  const ctaButton = computed(() => {
    if (brand?.adTemplate.value?.header.ctaButton) {
      return brand.adTemplate.value.header.ctaButton;
    }
    return {
      visible: false,
      text: "Bet Now",
      url: "",
      id: undefined
    };
  });
  return ctaButton.value;
}
